import  "./Map.css";
import React, {useState,useEffect,Fragment,useRef} from "react";
import SelectedMuseum from "./SelectedMuseum";
import { bool } from "prop-types";
import { withStyles } from "@material-ui/styles";
import "@babel/polyfill";

const citiesCategory =[
                        {id:1,city:'ירושלים',cityName:'Jerusalem',single:true},
                        {id:2,city:'תל אביב-יפו',cityName:'TelAviv',single:false},
                        {id:3,city:'אביחיל',cityName:'Avihayil',single:true},
                        {id:4,city:'חיפה',cityName:'Hifa',single:true},
                        {id:5,city:'עכו',cityName:'Acre',single:true},
                        {id:6,city:'כפר גלעדי',cityName:'kfarGiladi',single:true}];
                   
                       

//let restMuseums = [];


const useStyle = withStyles((theme) => ({
    typography:{
        padding:theme.spacing(2),
    },
}));

const MuseumsMap =  React.memo(props => {
    // constructor(props){
    //     super(props);

        const [museumNum,setMuseumNum]   = useState(2);
        const [selectMuseumCity,setSelectMuseumCity]   = useState(5);
        const [items,setItems]= useState([]);
        const [showTelAviv,setShowTelAviv]   = useState(false);
        //const [showJeruselem,setShowJeruselem]   = useState(false);
        // const [anchorEl,setAnchorEl]   = useState(null);
        const [mobile,setMobile]   = useState(window.innerWidth < 650);
        const [tablet,setTablet]   = useState(window.innerWidth < 1450 && window.innerWidth > 650);
        const [citiesGroup,setCitiesGroup]= useState([]);
        const myRef=useRef();
        const [telAvivMuseums,setTelAvivMuseums] =  useState([]);;
        //const [cityCategories,setcityCategories] = useState
      
  useEffect(() =>{

        setItems(props.items);
        let selectMuseumNum =1;
        var elem = {};
        var groupItems =(props.items.reduce((city,{MODMuseumCity,Title,MODMuseumNum,ID}) => {
            if(!city[MODMuseumCity]) city[MODMuseumCity] = [];
            elem = {};
            elem.museumNum = MODMuseumNum;
            elem.museumName = Title;
            elem.id=ID;
            city[MODMuseumCity].push(elem);
            return city;
        },{}));
        setCitiesGroup(groupItems);

         let telAvivMuseums = groupItems["תל אביב-יפו"];
        setTelAvivMuseums(telAvivMuseums);
         setMuseumNum(museumNum);
    
        },[]);

        useEffect(() =>{
            function handleResize() {
                let currenttablet= (window.innerWidth > 650) && (window.innerWidth < 1200);
                let currentmobile= window.innerWidth < 651;
                if(currentmobile !== mobile || currenttablet !== tablet){
    
                        setMobile(currentmobile);
                        setTablet(currenttablet);
                    }
            }
            window.addEventListener("resize", handleResize);
            return ()=> window.removeEventListener("resize", handleResize);
        },[mobile,tablet]);


    const clickCityHandler = (event,cityId,museumId) =>{
        let cityNum = cityId;
        let newMuseumNum;
        let adjustMuseumAvihailName;
    
        if(museumId == undefined)
        {
            if (citiesCategory[cityId-1].city=='אביחיל'){
                adjustMuseumAvihailName = 'מושב אביחיל';
                newMuseumNum = citiesGroup[adjustMuseumAvihailName][0].museumNum;
            }
            else{
                newMuseumNum = citiesGroup[citiesCategory[cityId-1].city][0].museumNum;
                
            }
           // museumNum = citiesGroup[citiesCategory[cityId-1].city][0].museumNum;
        }
        else
        {
            newMuseumNum = museumId;
        }
        setMuseumNum(newMuseumNum);
        setSelectMuseumCity(cityNum);
        // setAnchorEl(null);
        setShowTelAviv(false);
    };
    const clickMultiCityHandler = (event,cityId) =>{
        event.preventDefault();
        setShowTelAviv(!showTelAviv);
        // setAnchorEl(event.currentTarget);
        }
    
       const handleClose = ()=>
        {
            // setAnchorEl(null);
            //setShowJeruselem(false);
            setShowTelAviv(false);
        };
        let tlvPopover = (showTelAviv && items && telAvivMuseums &&
            <div id="telAvivPopover" open={showTelAviv} 
            // anchorOrigin={{vertical:'top', horizontal:'right'}} 
            className="modPopover tlvMapPopover"  onClose={handleClose} >
               <div className="PopoverTitle">המוזיאונים בתל אביב-יפו</div>
                    <ul className="TLVMuseumsItems">
                        { telAvivMuseums.map((museum,index) =>
                                    <li className="modPopoverItem" value={museum.museumNum} key={museum.id+"_"+index} 
                                    onClick={(event) => clickCityHandler(event,2,museum.museumNum)}>{museum.museumName}
                                    </li>
                            )}
                    </ul>
                       
            </div> 
        )


        let citiyData = citiesCategory.map((city,index) =>(
            <a id={city.cityName} title={city.city} key={index} onClick={(event) => city.single ? clickCityHandler(event,city.id) : 
                clickMultiCityHandler(event,city.id)} ref={myRef}  className={"cityName "+city.cityName+(selectMuseumCity == city.id ? " currentCity" : " ")} >
                    {city.city}
                    <i className="fas fa-map-marker-alt" />
            </a> 

        ));
    return (
        <div className="mapWrap">
               <div className="titleOnMobile">
               
                        <h4 className="visitText">{props.moreTitle}</h4>
                        <div className="subText">{props.subText}</div>
                    </div>
                <div className="imgMapWrap">
                    <div className="museumMapImgHP">
                        <img src={ mobile ? "../PublishingImages/mapMobile.png" : tablet ? "../PublishingImages/mapTablet.png" : "../PublishingImages/map.jpg"} className="imgMap" />
                    </div>
                    <div className="modText">
                        <div className="container">
                    
                            <div className="mapRightSideInfo">
                                    <div className="visibleOnDesktop">
                                        <h4 className="visitText">{props.moreTitle}</h4>
                                        <div className="subText">{props.subText}</div>
                                    </div>
                                    <div className="selectedMuseumInfo">
                                    
                                        <div className="rightSideMap">
                                        {items.length > 0 && museumNum != null ?
                                            <SelectedMuseum data={items[museumNum]} />
                                            : null  }
                                        </div>
                                    </div>
                            </div>
                            <div className="leftSideMap wp50">
                                {citiyData}
                                {tlvPopover}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobileSideMap">
                    <div className="rightSideMap">
                                        {items.length > 0 && museumNum != null ?
                                            <SelectedMuseum data={items[museumNum]} />
                                            : null  }
                                        </div>
                </div>
        </div>
    );
    //}
}
);
//export default React.memo(withStyles(styles)(MuseumsMap));
 export default MuseumsMap;